import React, {useEffect, useState} from 'react'
import { toast } from "react-toastify";
import { sendQuestionRequest } from '../utils/apiHandler';
import VoiceInput from './VoiceInput';

const Input = ({ setMessages, messages, verify, suggestionText, getIdTokenClaims, getAccessTokenWithPopup, logout, clientId, updateClient, questionKey, setQuestionKey, setInputMethod }) => {
    const [text, setText] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => {
        if (suggestionText.length > 0) {
            setText(suggestionText);
            // When suggestion is used, treat it as text input
            setInputMethod('text');
        }
    }, [suggestionText]);

    async function Messagehandler() {
        if (!text.trim()) {
            toast.error('Message cannot be empty');
            return;
        }

        // Set input method to text when sending via text field
        setInputMethod('text');

        const messageText = text; // Store the current text to use in message
        setText('');
        setIsProcessing(true);

        if (verify) {
            let tempMessages = messages;
            setMessages([...messages, {
                message: messageText
            }])
            try {
                let response = await sendQuestionRequest(getIdTokenClaims, getAccessTokenWithPopup, logout, messageText, clientId, questionKey)
                setMessages([...tempMessages, {
                    message: messageText,
                    explanation: response.data.explanation,
                    question_key: response.data.question_key,
                    batch_count: response.data.batch_count
                }])
                setQuestionKey(response.data.question_key)
                if(response.data.chat_intelligence_key && response.data.chat_intelligence_key !== '{}')
                    await updateClient(response.data.chat_intelligence_key)
            } catch (error) {
                console.error('Error sending message:', error);
                toast.error('Failed to send message. Please try again.');
            }
        }
        setIsProcessing(false);
    }

    // Handle voice transcription - will send immediately
    const handleTranscription = (transcript) => {
        setText(transcript);
        // Set input method to voice when using voice input
        setInputMethod('voice');
        // Auto-send immediately
        if (transcript.trim() !== '') {
            // We need to set the text first and then call Messagehandler
            // Using a separate function to handle this
            sendTranscribedMessage(transcript);
        }
    };

    // Special handler for transcribed messages to ensure they're sent
    const sendTranscribedMessage = async (transcript) => {
        if (!transcript.trim()) {
            return;
        }

        setIsProcessing(true);

        if (verify) {
            let tempMessages = messages;
            setMessages([...messages, {
                message: transcript
            }])
            try {
                let response = await sendQuestionRequest(getIdTokenClaims, getAccessTokenWithPopup, logout, transcript, clientId, questionKey)
                setMessages([...tempMessages, {
                    message: transcript,
                    explanation: response.data.explanation,
                    question_key: response.data.question_key,
                    batch_count: response.data.batch_count
                }])
                if(response.data.chat_intelligence_key && response.data.chat_intelligence_key !== '{}')
                    await updateClient(response.data.chat_intelligence_key)
            } catch (error) {
                console.error('Error sending message:', error);
                toast.error('Failed to send message. Please try again.');
            }
        }
        setText('');
        setIsProcessing(false);
    };

    return (
        <div className='relative ms-4 me-4'>
            {/* Input Box */}
            <div className='max-w-full mx-auto'>
                <div>
                    {/* <LoadingDots /> */}
                    {/* <MessageTwo/> */}
                    {/* <MessageThree/> */}
                    {/* <RangeSelector/> */}

                </div>
                <div
                    className={`grid mt-3 lg:mt-4`}
                >
                    <div className="border-[#dadee7] border w-full flex justify-between p-2 lg:p-3 bg-white rounded-md">
                        <div className="flex items-center mr-2">
                            <VoiceInput
                                onTranscribe={handleTranscription}
                                getIdTokenClaims={getIdTokenClaims}
                                getAccessTokenWithPopup={getAccessTokenWithPopup}
                                logout={logout}
                                disabled={isProcessing}
                            />
                        </div>
                        <input
                            onChange={(e) => {
                                setText(e.target.value);
                                // Mark as text input when user types
                                setInputMethod('text');
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !isProcessing) {
                                    Messagehandler();
                                }
                            }}
                            value={text}
                            className='w-full outline-none border-none'
                            type="text"
                            placeholder='Send a message'
                            disabled={isProcessing}
                        />
                        <button
                            onClick={() => {
                                if (!isProcessing) Messagehandler();
                            }}
                            disabled={isProcessing}
                            className={`bg-[#0062ff] py-2 px-3 text-white rounded-lg transition-transform duration-300 hover:scale-105 ${
                                isProcessing ? 'opacity-70 cursor-not-allowed' : ''
                            }`}
                        >
                            Send
                        </button>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Input